"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9002],{

/***/ 9072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_ApplicationCTA; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./public/assets/images/home/playStoreBlack.svg
var playStoreBlack = __webpack_require__(5355);
;// CONCATENATED MODULE: ./public/assets/images/home/app-mockup-Photoroom.png
/* harmony default export */ var app_mockup_Photoroom = ({"src":"/_next/static/media/app-mockup-Photoroom.e3415cd4.png","height":1280,"width":666,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAMFBMVEXLy8zO0NGJl56lpcSLprWnrbKof6Zyd8e6uMXt8vP2+Prx7O2+xOtmc+bFx+mSe8rakfB3AAAACXRSTlO/xXzMvHzCvsQbp4SuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVR4nAXBiREAIAgEsT1AHcCn/25NsAjD93XWeRM6QZlAl1CVGGAfDz8AsE0IeHAAAAAASUVORK5CYII=","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/app-mockup (1)-Photoroom.png
/* harmony default export */ var app_mockup_1_Photoroom = ({"src":"/_next/static/media/app-mockup (1)-Photoroom.7d3d826d.png","height":1280,"width":666,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAJ1BMVEXT1daxwdAtZJfFx8olZ6gfZafU2Nivrq6YmZv7/fzw9/bM4PPM4vbIctHaAAAACXRSTlPBzHy8vLzLfHxyQdH4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVR4nGNgYmFlYmDk5mFkYODkZGBg4AIREBYXAwMbiMXOzMwBAAv7AJ/pQ4DTAAAAAElFTkSuQmCC","blurWidth":4,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./utils/Constants.ts
var Constants = __webpack_require__(953);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/ApplicationCTA.tsx










function ApplicationCTA() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        sx: {
            minHeight: {
                xs: "auto",
                md: "60vh"
            },
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: {
                xs: "50px 0",
                md: "120px 0"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            style: {
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                height: "90%",
                width: "85%",
                background: "linear-gradient(60.24deg, #08AC17 -21.65%, #4D71D0 93.65%)",
                color: "white",
                borderRadius: "15px",
                maxWidth: "1440px",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        width: {
                            xs: "100%",
                            md: "50%"
                        },
                        padding: {
                            xs: "5% 8%",
                            md: "3% 8%"
                        }
                    },
                    style: {
                        height: "100%",
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            fontWeight: "bold",
                            sx: {
                                fontSize: {
                                    xs: "25px",
                                    md: "36px"
                                }
                            },
                            children: "Sell More To Earn More! with Zero Investment"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            sx: {
                                fontSize: {
                                    xs: "16px",
                                    md: "20px"
                                },
                                margin: {
                                    xs: "5% 0"
                                }
                            },
                            children: "Download the app today."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            style: {
                                display: "flex",
                                // justifyContent: "center",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: {
                                    height: {
                                        xs: "45px",
                                        md: "60px"
                                    },
                                    width: "auto",
                                    margin: "5px",
                                    display: {
                                        xs: "none",
                                        md: "block"
                                    },
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: Constants/* appLink */.ze,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: playStoreBlack/* default */.Z,
                                        alt: "Get it on Google Play",
                                        width: 200,
                                        height: 200
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "none",
                            md: "block"
                        }
                    },
                    style: {
                        width: "50%",
                        position: "absolute",
                        top: "-5%",
                        bottom: "-5%",
                        right: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: app_mockup_Photoroom,
                            loading: "lazy",
                            placeholder: "blur",
                            alt: "GroMo app preview on an Android phone",
                            width: 500,
                            height: 800,
                            style: {
                                position: "absolute",
                                left: "26%",
                                zIndex: "1",
                                objectFit: "contain"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: app_mockup_1_Photoroom,
                            loading: "lazy",
                            width: 400,
                            height: 700,
                            alt: "GroMo app preview on a phone",
                            style: {
                                position: "absolute",
                                left: "44%",
                                objectFit: "contain",
                                marginTop: "2%"
                            }
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var components_ApplicationCTA = (ApplicationCTA);


/***/ })

}]);